import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IRtpSendTransaction } from '../../interfaces/send-payment/rtp-send-payment.interface';
import { AbstractRtpSendPaymentService } from '../abstraction/abstract.rtp-send-payment.service';

@Injectable({
  providedIn: 'root',
})
export class RtpSendPaymentService extends AbstractRtpSendPaymentService {
  private controllerUrl = `/manager/rtp/send-payment`;
  private apiUrl = `${environment.apiUrl}${this.controllerUrl}`;

  constructor(private http: HttpClient) {
    super();
  }

  sendTransaction(transaction: IRtpSendTransaction): Promise<IWebMessage | undefined> {
    return firstValueFrom(this.http.post<IWebMessage>(`${this.apiUrl}/send`, transaction));
  }
}
